import { PagedSearch } from '../../../shared/model/paged-search.model';

export class CommitteesByRelatedProfileSearchDto extends PagedSearch {
  ProfileId: number;
  IncludeInactive: boolean;
}
